import * as React from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { buttonBaseClasses, buttonClasses } from "@mui/material";

import { MzMenu, MzMenuItem } from "@markaaz/ui/MzMenuControls";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  button: {
    zIndex: "111",
    maxWidth: "135px",
    [`&.${buttonBaseClasses.root}.${buttonClasses.root}.${buttonClasses.outlined}.${buttonClasses.outlinedSecondary}`]:
      {
        color: "darkBlue.c100"
      }
  }
};

const MenuComponent = ({ label, options, disabled, profile }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      {profile ? (
        <MzButton onClick={handleClick}>{label}</MzButton>
      ) : (
        <MzButton
          variant="outlined"
          color="secondary"
          sx={sx.button}
          endIcon={<KeyboardArrowDown />}
          onClick={handleClick}
        >
          {label}
        </MzButton>
      )}
      <MzMenu sx={{ maxWidth: "150px", zIndex: "111" }} anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map((val) => (
          <MzMenuItem key={val.label} onClick={val.onClick}>
            {val.label}
          </MzMenuItem>
        ))}
      </MzMenu>
    </div>
  );
};

export default MenuComponent;
